import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { tss } from 'tss-react';

import * as State from 'components/desktop/Ingredient/IngredientProducts/OrderGuideMapping/State';
import ProductListItem from 'components/desktop/Ingredient/IngredientProducts/OrderGuideMapping/components/ProductListItem';
import { Handlers } from 'components/desktop/Ingredient/IngredientProducts/OrderGuideMapping/useState';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import LoadingSpinner from 'components/desktop/_general/Loading/LoadingSpinner';
import Overlay from 'components/desktop/_general/Overlay/Overlay';

interface IProps {
	ingredientId: string;
	state: State.Type;
	handlers: Handlers;
}

const ProductSearchOverlay = (props: IProps) => {
	const { classes } = useStyles();

	const { t } = useTranslation();
	const [searchTerm, setSearchTerm] = useState('');
	const [isLoaded, setIsLoaded] = useState(true);

	const search = async () => {
		setIsLoaded(false);
		await props.handlers.searchProducts({
			ingredientId: props.ingredientId,
			searchTerm: searchTerm,
			type: 'name',
		});
		setIsLoaded(true);
	};

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearchTerm(e.target.value);
	};

	const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>): void => {
		if (e.key !== 'Enter') return;
		search();
	};

	return (
		<Overlay
			displayOverlay={props.state.isProductSearchOpen}
			handleClose={props.handlers.closeProductSearch}
		>
			<div className={classes.productListContainer}>
				<div className="input-group mb-3">
					<input
						type="text"
						className="form-control"
						placeholder={'...'}
						value={searchTerm}
						onChange={onChange}
						onKeyDown={handleKeyDown}
					/>
					<div className="input-group-append">
						<button
							className="btn btn-primary"
							type="button"
							id="button-addon1"
							onClick={search}
						>
							{t('_general:BTN_SEARCH')}
						</button>
					</div>
				</div>
				<RenderIf condition={Boolean(!props.state.searchedProducts.length) && isLoaded}>
					<div>{t('ingredient:NO_PRODUCTS_FOUND')} </div>
				</RenderIf>
				<RenderIf condition={!isLoaded}>
					<LoadingSpinner />
				</RenderIf>
				<RenderIf condition={Boolean(isLoaded)}>
					<div>
						{props.state.searchedProducts.map((product, i) => (
							<ProductListItem
								key={i}
								product={product}
								togglePriority={props.handlers.togglePriority}
								selectProduct={(product) =>
									props.handlers.addProduct({
										product,
									})
								}
							/>
						))}
					</div>
				</RenderIf>
			</div>
		</Overlay>
	);
};

export default ProductSearchOverlay;

export const useStyles = tss.create({
	productListContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
		minWidth: '400px',
		width: '800px',
		maxWidth: '800px',
	},
});
